<script>
    import Icon from '../icons/Icon.svelte';

    export let isOpen = false;
    export let editingFeeId = null;
    export let neighborhood = '';
    export let fee = 7.00;
    export let estimatedMinutes = 45;
    export let isSaving = false;
    export let onSave = () => {};
    export let onClose = () => {};
</script>

{#if isOpen}
    <div class="modal-overlay" on:click|self={onClose}>
        <div class="modal-card">
            <header class="modal-header">
                <div class="header-info">
                    <span class="modal-badge">ENTREGA POR REGIÃO</span>
                    <h3>{editingFeeId ? 'Editar Bairro / Taxa' : 'Novo Bairro / Região Atendida'}</h3>
                </div>
                <button type="button" class="btn-close" on:click={onClose}>
                    <Icon name="x" size={16} />
                </button>
            </header>

            <form on:submit|preventDefault={onSave} class="modal-form">
                <div class="form-group">
                    <label for="fee-neighborhood">Nome do Bairro / Região *</label>
                    <input
                        id="fee-neighborhood"
                        type="text"
                        bind:value={neighborhood}
                        placeholder="Ex: Jardim das Américas"
                        class="form-input"
                        required
                    />
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="fee-val">Taxa de Entrega (R$) *</label>
                        <div class="prefix-box">
                            <span class="prefix">R$</span>
                            <input
                                id="fee-val"
                                type="number"
                                step="0.50"
                                min="0"
                                bind:value={fee}
                                placeholder="8.00"
                                class="form-input with-prefix"
                                required
                            />
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="fee-mins">Tempo Estimado (min)</label>
                        <input
                            id="fee-mins"
                            type="number"
                            step="5"
                            min="10"
                            bind:value={estimatedMinutes}
                            placeholder="45"
                            class="form-input"
                        />
                    </div>
                </div>

                <footer class="modal-footer">
                    <button type="button" class="btn-cancel" on:click={onClose}>
                        Cancelar
                    </button>
                    <button type="submit" class="btn-save" disabled={isSaving}>
                        <Icon name="check" size={14} />
                        <span>{isSaving ? 'Salvando...' : 'Salvar Bairro'}</span>
                    </button>
                </footer>
            </form>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.5);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 14px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    .modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 18px 22px;
        border-bottom: 1px solid #E2E8F0;
        background: #FFFFFF;
    }

    .modal-badge {
        font-size: 0.68rem;
        font-weight: 700;
        color: #FF6A00;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        display: block;
        margin-bottom: 3px;
    }

    .modal-header h3 {
        font-size: 1.1rem;
        font-weight: 700;
        color: #0F172A;
        margin: 0;
    }

    .btn-close {
        background: none;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 4px;
        border-radius: 6px;
        transition: all 0.2s;
    }

    .btn-close:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-form {
        padding: 20px 22px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        background: #FFFFFF;
    }

    .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 0.78rem;
        font-weight: 600;
        color: #475569;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 9px 12px;
        color: #0F172A;
        font-size: 0.86rem;
        transition: all 0.2s ease;
    }

    .form-input:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .prefix-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .prefix {
        position: absolute;
        left: 10px;
        font-size: 0.8rem;
        color: #64748B;
        font-weight: 600;
        pointer-events: none;
    }

    .form-input.with-prefix {
        padding-left: 32px;
        width: 100%;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        padding-top: 14px;
        border-top: 1px solid #E2E8F0;
    }

    .btn-cancel {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 8px 14px;
        border-radius: 6px;
        font-size: 0.82rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-save {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #fff;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 0.82rem;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
        transition: all 0.2s;
    }

    .btn-save:hover {
        background: #EA580C;
    }
</style>
